__webpack_require__.p = "/ypo-gold-istanbul/";